<template>
  <div class="otsMainTitle">
    <template v-if="isReviewTimeSet">
      <div class="PlanBox">
        <ots-main-title></ots-main-title>
        <div class="mainCon">
          <ots-table-group
            :tableHeader="tableHeader"
            :tableData="tableData"
            :pagination="pagination"
            @changeNum="changeSize"
            @changePage="changePage"
          ></ots-table-group>
        </div>
      </div>
      <ots-custom-dialog
        :dialog.sync="addDialog"
        title="评阅时间设置"
        width="40%"
      >
        <template v-slot:content>
          <el-form ref="form" :rules="rules" :model="form" :inline="true">
            <div class="sectionBox">
              <el-form-item label="评阅开始时间" prop="teacherReviewBeginTime">
                <el-date-picker
                  :value-format="dataFormat"
                  v-model="form.teacherReviewBeginTime"
                  type="datetime"
                  placeholder="选择开始日期时间"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="评阅结束时间" prop="teacherReviewEndTime">
                <el-date-picker
                  :value-format="dataFormat"
                  v-model="form.teacherReviewEndTime"
                  type="datetime"
                  placeholder="选择结束日期时间"
                >
                </el-date-picker>
              </el-form-item>
            </div>
          </el-form>
        </template>
        <template v-slot:footer>
          <el-button round @click="addDialog = false">取消</el-button>
          <el-button round type="primary" @click="addStation(setTime)"
            >确定</el-button
          >
        </template>
      </ots-custom-dialog>
    </template>
    <template v-else>
      <router-view></router-view>
    </template>
  </div>
</template>
<script>
import {
  getTeacherReviewTimeListSet,
  updateTeacherReviewTimeSet,
  judgeHaveTeacherquery
} from "@/http/modules/markPaper";
export default {
  data() {
    return {
      tableHeader: [
        {
          title: "考试批次",
          prop: "planCode",
        },
        {
          title: "批次名称",
          prop: "planName",
        },
        {
          title: "启用状态",
          prop: "stateName",
        },
        {
          title: "考试批次状态",
          prop: "planStateName",
        },
        {
          title: "考试开始时间",
          prop: "scoreBeginTime",
        },
        {
          title: "评阅开始时间",
          prop: "teacherReviewBeginTime",
        },
        {
          title: "评阅结束时间",
          prop: "teacherReviewEndTime",
        },
        {
          title: "操作",
          type: "buttons",
          width: "100",
          btnList: [
            {
              title: "评阅时间设置",
              disableFn: (val) => (val.row.changeFlag == 1 ? false : true),
              click: this.setTime,
            },
          ],
        },
      ],
      requestForm: {
        page: 1,
        size: 10,
      },
      tableData: [],
      pagination: {
        total: 0,
        page: 1,
      },
      PlanListParams: {
        order: "",
        page: 1,
        size: 10,
      },
      form: {
        teacherReviewBeginTime: "",
        teacherReviewEndTime: "",
      },
      dataFormat: "yyyy-MM-dd HH:mm:ss",
      addDialog: false,
      rules: {
        teacherReviewBeginTime: [
          { required: true, message: "请选择评阅开始时间", trigger: "change" },
        ],
        teacherReviewEndTime: [
          { required: true, message: "请选择评阅结束时间", trigger: "change" },
        ],
      },
    };
  },
  created() {
    this.getTeacherReviewTimeList();
  },
  computed: {
    isReviewTimeSet() {
      return this.$route.name === "reviewTimeSet";
    },
  },
  methods: {
    changeSize(num) {
      this.PlanListParams.size = num;
      this.getTeacherReviewTimeList();
    },
    changePage(p) {
      this.PlanListParams.page = p;
      this.pagination.page = p;
      this.getTeacherReviewTimeList();
    },
    async getTeacherReviewTimeList() {//列表
      let params = Object.assign({}, this.PlanListParams, {
        publish: 1,
        state: 1,
      });
      const { data } = await getTeacherReviewTimeListSet(params);
      this.tableData = data.records;
      this.pagination.total = data.total;
    },
    setTime(row) {//评阅时间设置
      judgeHaveTeacherquery({planId:row.planId}).then(res=>{
        if(res.data === true){
          this.addDialog = true;
          this.form.teacherReviewBeginTime = row.teacherReviewBeginTime;
          this.form.teacherReviewEndTime = row.teacherReviewEndTime;
          this.form.planId = row.planId;
        }else{
          this.$message.error('请先进行评阅教师分配')
        }
      })
      
    },
    addStation() {//评阅时间设置保存
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          let BeginTime = new Date(this.form.teacherReviewBeginTime);
          let EndTime = new Date(this.form.teacherReviewEndTime);
          if (BeginTime >= EndTime) {
            this.$message.error("教师评阅结束时间要晚于教师评阅开始时间");
            this.addDialog = false;
            return;
          } else {
            updateTeacherReviewTimeSet(this.form).then((res) => {
              if (res.code === 1) {
                this.addDialog = false;
                this.getTeacherReviewTimeList();
                this.$message({
                  message: "更新成功",
                  type: "success",
                });
              } else {
                this.addDialog = false;
              }
            });
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-input .el-input__inner {
  line-height: 34px;
  height: 34px;
}
.sectionBox{
  line-height: 40px;
}
</style>